export const addNoteValidate = addNoteInfo => {

    const errors = {}

    if (!addNoteInfo.title.trim()) {
        errors.title = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.title
    }

    if (!addNoteInfo.description.trim()) {
        errors.description = "لطفا متن یادداشت را وارد کنید"
    } else {
        delete errors.description
    }

    return errors;
}